import * as React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';

const logoUrl = Tgcc.ResolveUrl('~/images/PrimaryLogo.svg');

interface CedLandingProps {}
interface CedLandingState {
  error?: string;
}

class CedLanding extends React.Component<CedLandingProps, CedLandingState> {
  state: CedLandingState = {};

  componentDidMount() {
    Request.fetchCurrentCedTvite(
      (details) => {
        browserHistory.push(details.url);
      },
      (err) => {
        console.error('Failed to fetch current CED T-Vite:', err);
        this.setState({ error: 'This CED order link is not available right now. Please check back soon.' });
      }
    );
  }

  render() {
    if (this.state.error) {
      return (
        <div style={styles.container}>
          <a href="https://www.thegraphiccowcompany.com/" target="_blank" rel="noopener noreferrer">
            <img src={logoUrl} alt="Company Logo" style={styles.logo} />
          </a>
          <h1 style={styles.header}>{this.state.error}</h1>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state: Tgcc.GlobalState) => ({});

export default connect(mapStateToProps)(CedLanding);

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    margin: '40px auto',
  },
  logo: {
    maxWidth: '200px',
    margin: '20px auto',
  },
  header: {
    fontSize: '1.5em',
    color: '#333',
    marginBottom: '10px',
  },
};
